import 'jquery';
import '@popperjs';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import 'aos';
import 'jquery-match-height';
import './back-to-top.js';
import './header.js';
import './home.js';
import './slick.js';